export default "__VITE_ASSET__DwPihEpR__";